import * as type from './type';
import util from 'common/js/util';

export default {
    //获取待申请列表
    [type.GET_PENDING_LISTS](context, option) {
        util.post({
            params: {
                functionId: "getAbleInvoiceOrderList",
                body: JSON.stringify({
                    orderId: option.params.orderId,
                    pageNo: option.params.pageNo,
                    pageSize: option.params.pageSize,
                    ifAsc: option.params.ifAsc,
                })
            },
            sc(data) {
                if (option && option.sc) {
                    option.sc && option.sc(data);
                }
            },
            fc(data) {
                if (option && option.fc) {
                    option.fc && option.fc(data);
                }
            }
        });
    },

    //获取已生效列表
    [type.GET_EFFECTIVE_LISTS](context, option) {
        util.post({
            params: {
                functionId: "getInvoiceList",
                body: JSON.stringify({
                    invoiceId: option.params.orderId,
                    pageNo: option.params.pageNo,
                    pageSize: option.params.pageSize,
                    ifAsc: option.params.ifAsc
                })
            },
            sc(data) {
                if (option && option.sc) {
                    option.sc && option.sc(data);
                }
            },
            fc(data) {
                if (option && option.fc) {
                    option.fc && option.fc(data);
                }
            }
        });
    },

    //获取已申请/已拒绝列表
    [type.GET_APPLY_REFUSE_LISTS](context, option) {
        util.post({
            params: {
                functionId: "getInvoiceApplyList",
                body: JSON.stringify({
                    orderId: option.params.orderId,
                    pageNo: option.params.pageNo,
                    pageSize: option.params.pageSize,
                    ifAsc: option.params.ifAsc,
                    isReject: option.params.isReject
                })
            },
            sc(data) {
                if (option && option.sc) {
                    option.sc && option.sc(data);
                }
            },
            fc(data) {
                if (option && option.fc) {
                    option.fc && option.fc(data);
                }
            }
        });
    },

    //申请发票
    [type.APPLY_INVOICE](context, option) {
        util.post({
            params: {
                functionId: "applyInvoice",
                body: JSON.stringify({
                    orderIds: option.params.orderIds,
                })
            },
            sc(data) {
                if (option && option.sc) {
                    option.sc && option.sc(data);
                }
            },
            fc(data) {
                if (option && option.fc) {
                    option.fc && option.fc(data);
                }
            }
        });
    },

    //取消发票
    [type.CANCEL_INVOICE](context, option) {
        util.post({
            params: {
                functionId: "cancelInvoiceApply",
                body: JSON.stringify({
                    applyId: option.params.applyId,
                })
            },
            sc(data) {
                if (option && option.sc) {
                    option.sc && option.sc(data);
                }
            },
            fc(data) {
                if (option && option.fc) {
                    option.fc && option.fc(data);
                }
            }
        });
    },

    //获取发票信息
    [type.GET_INVOICE_INFO](context, option) {
        util.post({
            params: {
                functionId: "getInvoiceInfo",
                body: JSON.stringify({
                    invoiceOrgIds: option.params.invoiceOrgIds,
                    invoiceAmount: option.params.invoiceAmount
                })
            },
            sc(data) {
                context.commit(type.SET_INVOICE_INFO, data.data);
                if (option && option.sc) {
                    option.sc && option.sc(data);
                }
            },
            fc(data) {
                if (option && option.fc) {
                    option.fc && option.fc(data);
                }
            }
        });
    },

    //获取物流信息
    [type.CHECK_LOGISTICS](context, option) {
        util.post({
            params: {
                functionId: "getTrackInfo",
                body: JSON.stringify({
                    financeNo: option.params.financeNo,
                    deliveryNo: option.params.deliveryNo
                })
            },
            sc(data) {
                context.commit(type.SET_LOGISTICS, data.data);
                if (option && option.sc) {
                    option.sc && option.sc(data);
                }
            },
            fc(data) {
                if (option && option.fc) {
                    option.fc && option.fc(data);
                }
            }
        });
    },

    //获取申请单详情
    [type.GET_INVOICE_APPLY_DETAIL](context, option) {
        util.post({
            params: {
                functionId: "getInvoiceApplyDetail",
                body: JSON.stringify({
                    applyId: option.params.applyId,
                    applyDate: option.params.applyDate,
                    orderIds: option.params.orderIds,
                    applyState:  option.params.applyState,
                    showButton: option.params.showButton
                })
            },
            sc(data) {
                context.commit(type.SET_INVOICE_APPLY_DETAIL, data.data);
                if (option && option.sc) {
                    option.sc && option.sc(data);
                }
            },
            fc(data) {
                if (option && option.fc) {
                    option.fc && option.fc(data);
                }
            }
        });
    },
}


// WEBPACK FOOTER //
// ./src/store/invoice-manage/actions.js